import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Icon from "@Shared/components/general/fa-icon";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { debounce } from "lodash";
import ReferrerListFilters from "./referrer-list-filters.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerActions",
  components: {
    Icon,
    SimpleButton,
    ReferrerListFilters
  },
  props: {
    searchString: {
      type: String,
      default: ""
    }
  },
  computed: {
    searchReferrer: {
      get() {
        return this.searchString;
      },
      set: debounce(function (text) {
        if (text.length && _trimInstanceProperty(text).call(text).length <= 2) return;
        this.$emit("search", _trimInstanceProperty(text).call(text));
      }, 200)
    }
  },
  methods: {
    handleAddReferrer() {
      this.$emit("add");
    },
    handleFilters(data) {
      this.$emit("filter", data);
    },
    clearFilter(data) {
      this.$refs.referrerFilters.clearFilter(data);
    }
  }
});